import React, { FC } from 'react'

import { FormattedMessage } from 'react-intl'

import { Colors } from 'common-constants/colors'
import { Note } from 'components/presentational'

export const ProfileGiftDetails: FC<{
  isGiftFromCurrentUser: boolean
  state: boolean
}> = ({ isGiftFromCurrentUser, state }) => {
  /**
   * Если удален или заблокирован.
   */
  if (state) {
    return (
      <Note color={Colors.black} $margin="0px" fontWeightBold={true}>
        <FormattedMessage
          id="app.account_deleted"
          defaultMessage="Анкета удалена"
        />
      </Note>
    )
  }

  /**
   * Если подарок смотрит тот, кто подарил его
   */
  if (isGiftFromCurrentUser) {
    return (
      <Note color={Colors.black} $margin="0px">
        <FormattedMessage
          id="stream.gift.anonymously_current_user"
          defaultMessage="Только получатель будет видеть ваше имя и подпись"
        />
      </Note>
    )
  }

  /**
   * Если смотрят все остальные
   */
  return (
    <Note color={Colors.black} $margin="0px">
      <FormattedMessage
        id="stream.gift.anonymously"
        defaultMessage="Даритель пожелал остаться неизвестным"
      />
    </Note>
  )
}
